import ImagesSkusArrowRightSvg from '@/public/images/skus/arrow-right.svg';
import ImagesSkusChevronDownSvg from '@/public/images/skus/chevron-down.svg';
import ImagesSkusCloseSvg from '@/public/images/skus/close.svg';
import ImagesSkusFiltersBlackSvg from '@/public/images/skus/filters-black.svg';
import ImagesSkusFiltersSvg from '@/public/images/skus/filters.svg';
import ImagesSkusGridSvg from '@/public/images/skus/grid.svg';
import ImagesSkusHouseSvg from '@/public/images/skus/house.svg';
import ImagesSkusListSvg from '@/public/images/skus/list.svg';
import ImagesSkusSearchSvg from '@/public/images/skus/search.svg';
import ImagesSkusSortSvg from '@/public/images/skus/sort.svg';

export {
  ImagesSkusArrowRightSvg,
  ImagesSkusChevronDownSvg,
  ImagesSkusCloseSvg,
  ImagesSkusFiltersBlackSvg,
  ImagesSkusFiltersSvg,
  ImagesSkusGridSvg,
  ImagesSkusHouseSvg,
  ImagesSkusListSvg,
  ImagesSkusSearchSvg,
  ImagesSkusSortSvg,
};
